import { organizationSchema, getOrganizationsResponseSchema, } from '@consigli/types';
import { createTransformer, mapToSnakeCase } from './shared/base-api';
export const organizationApiEndpoints = (builder, coreApiBaseUrl) => ({
    createOrganization: builder.mutation({
        query: ({ createOrg }) => ({
            url: `${coreApiBaseUrl}/organizations/`,
            method: 'POST',
            body: mapToSnakeCase(createOrg),
        }),
        invalidatesTags: ['Organization'],
        transformResponse: createTransformer(organizationSchema, 'createOrganization'),
    }),
    getOrganizations: builder.query({
        query: () => ({
            url: `${coreApiBaseUrl}/organizations/`,
        }),
        providesTags: ['Organization'],
        transformResponse: createTransformer(getOrganizationsResponseSchema, 'getOrganizations'),
    }),
    getOrganization: builder.query({
        query: ({ id }) => ({
            url: `${coreApiBaseUrl}/organizations/${id}/`,
        }),
        providesTags: ['Organization'],
        transformResponse: createTransformer(organizationSchema, 'getOrganization'),
    }),
    updateOrganization: builder.mutation({
        query: ({ organizationId, data }) => ({
            url: `${coreApiBaseUrl}/organizations/${organizationId}/`,
            method: 'PATCH',
            body: mapToSnakeCase(data),
        }),
        invalidatesTags: ['Organization', 'Projects'],
        transformResponse: createTransformer(organizationSchema, 'UpdateOrganization'),
    }),
});
